module.exports = __webpack_public_path__ + "static/social-6e25bfb2f8c5cf1d5d1e2d4595052ee5.png";